import {createAction} from '@reduxjs/toolkit';

import {AppMode, CurrentStoreType} from 'store/types/app';
import {MembershipCard, StoreAreas, VerifyVoucherResponse} from 'types';

export const fetchMakroMembershipCardAction = createAction<string>('FETCH_MAKRO_MEMBERSHIP_CARD');

export const setMembershipCardsAction = createAction<MembershipCard[]>('SET_MEMBERSHIP_CARDS');

export const setDefaultMembershipCardAction = createAction<MembershipCard | undefined>('SET_DEFAULT_MEMBERSHIP_CARD');

export const applyVoucherAction = createAction<string>('APPLY_VOUCHER');
export const setVoucherDataAction = createAction<VerifyVoucherResponse | undefined>('SET_VOUCHER_DATA');
export const removeVoucherAction = createAction<string>('REMOVE_VOUCHER');

export const setCurrentStoreAction = createAction<CurrentStoreType>('SET_CURRENT_STORE');

export const getStoreAreasAction = createAction('GET_CURRENT_STORE_AREAS');

export const setStoreAreasAction = createAction<StoreAreas[]>('SET_STORE_AREAS_ACTION');

export const setIsDirectCheckoutAction = createAction<boolean>('SET_IS_DIRECT_CHECKOUT');
export const setAccessTradeClickIdAction = createAction<string | undefined>('SET_ACCESSTRADE_CLICK_ID');
export const setPricezaClickIdAction = createAction<string | undefined>('SET_PRICEZA_CLICK_ID');

export const setIsAppLoadingAction = createAction<boolean>('SET_IS_APP_LOADING');

export const setAppModeAction = createAction<AppMode>('SET_APP_MODE');
export const setAppVersionAction = createAction<string>('SET_APP_VERSION');
export const setDeviceOSAction = createAction<string>('SET_DEVICE_OS');
